<div [ngClass]="{ 'section-separator': showSectionSeparator }"></div>
<div class="title-icon">
	<h3 class="d-inline-block">
		<span class="icon-caption title-main" [dcrHTMLKey]="titleDcr">
			<span>{{ title }}</span>
		</span>
	</h3>

	<icon
		type="info-circle"
		*ngIf="tooltipText; else dcrTooltip"
		class="info-circle text-14 color-primary"
		[tooltip]="infoBubble"
		[analytic-data]="{ linkName: titleDcr + '_TOOLTIP' }"
	>
	</icon>
	<ng-template #dcrTooltip>
		<icon type="info-circle" *ngIf="tooltipDcr" class="info-circle text-14 color-primary" [tooltip-dcr]="tooltipDcr" [analytic-data]="{ linkName: tooltipDcr + '_TOOLTIP' }">
		</icon>
	</ng-template>
</div>
<ng-template #infoBubble> <section [innerHTML]="tooltipText"></section> </ng-template>
<div *ngIf="poweredByDcr" class="text-16-bold" dcrHTMLKey="poweredByDcr">{{ poweredByDefaultText }}</div>
<div *ngIf="asOfDate" class="margin-top-10 text-16"><span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ $asOfDate$: asOfDate }">As of $asOfDate$</span></div>
<div class="margin-bottom-15 text-16" [dcrHTMLKey]="subTitleDcr">
	<span>{{ subTitle }}</span>
</div>
